(function () {

  function openSetStoreModal() {
    try {
      const components = document.querySelectorAll('store-locator-component');

      for (const comp of components) {
        if (!(comp instanceof HTMLElement)) continue;
        const isVisible = comp.getClientRects().length > 0;
        if (!isVisible) continue;

        /** @type {any} */
        const instance =
          comp.shadowRoot?.querySelector('store-locator-component') || comp;

        if (instance && typeof instance.openSetStoreModal === 'function') {
          instance.openSetStoreModal();
          return;
        }
      }

      /** @type {HTMLElement | null} */
      const modal = document.querySelector('#set-store-modal');
      if (!modal) return;

      /** @type {any} */
      const dialogComponent = modal.querySelector('dialog-component');
      if (dialogComponent && typeof dialogComponent.showDialog === 'function') {
        dialogComponent.showDialog();
        return;
      }

      const dialogEl = modal.querySelector('dialog');
      if (dialogEl && typeof dialogEl.showModal === 'function') {
        dialogEl.showModal();
      }
    } catch {
    }
  }

  /**
   * @param {HTMLAnchorElement | HTMLButtonElement | HTMLElement | null} button
   * @returns {string | null}
   */
  function getStoreLocatorBaseUrl() {
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    return `${origin}/pages/store`;
  }

  /**
   * @param {unknown} value
   * @returns {string | null}
   */
  function parseShopifyLocationId(value) {
    if (value == null || value === '') return null;
    const s = String(value).trim();
    if (s.startsWith('gid://')) {
      const segment = s.split('/').pop();
      return segment || null;
    }
    if (/^\d+$/.test(s)) return s;
    return null;
  }

  /**
   * @param {any} store
   * @returns {string | null}
   */
  function getStoreLocationIdForUrl(store) {
    if (!store) return null;

    const apiId = store._apiData && store._apiData.id;
    if (apiId) {
      const fromApi = parseShopifyLocationId(apiId);
      if (fromApi) return fromApi;
    }

    const topId = store.id;
    if (topId == null || topId === '') return null;
    const topStr = String(topId);
    if (topStr.startsWith('geocoded_')) {
      return null;
    }

    return parseShopifyLocationId(topStr);
  }

  /**
   * @param {string} baseUrl
   * @param {any} preferredStore
   * @returns {string | null}
   */
  function buildHrefWithHandle(baseUrl, preferredStore) {
    const handle = preferredStore?._apiData?.storePage?.reference?.handle;
    if (!handle) return null;

    const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    return cleanBaseUrl + '/' + encodeURIComponent(handle);
  }

  async function updateContactButtons() {
    const buttons = document.querySelectorAll('[data-category-faq-contact]');
    if (!buttons.length) return;

    const win = /** @type {any} */ (window);
    const hasPreferredStoreFn = typeof win !== 'undefined' && typeof win.getPreferredStore === 'function';
    let preferredStore = null;

    if (hasPreferredStoreFn) {
      try {
        preferredStore = await win.getPreferredStore();
      } catch (e) {
        console.error('Error getting preferred store for Category FAQ:', e);
      }
    }

    buttons.forEach((button) => {
      const baseUrl = getStoreLocatorBaseUrl();
      if (!baseUrl) return;

      const withId = buildHrefWithHandle(baseUrl, preferredStore);
      if (withId) {
        button.setAttribute('href', withId || baseUrl);
      }
    });
  }

  /**
   * @param {MouseEvent} event
   */
  async function handleCategoryFaqContactClick(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const anchor = target.closest('[data-category-faq-contact]');
    if (!anchor || !(anchor instanceof HTMLAnchorElement)) return;

    const modified =
      event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
    if (modified || event.button !== 0) {
      return;
    }

    event.preventDefault();

    const win = /** @type {any} */ (window);
    if (typeof win.getPreferredStore !== 'function') {
      openSetStoreModal();
      return;
    }

    let preferredStore = null;
    try {
      preferredStore = await win.getPreferredStore();
    } catch (e) {
      console.error('Category FAQ contact: getPreferredStore failed', e);
    }

    const baseUrl = getStoreLocatorBaseUrl();
    if (!baseUrl) return;

    let hrefWithHandle = buildHrefWithHandle(baseUrl, preferredStore);

    if (!hrefWithHandle) {
      // openSetStoreModal();
      // return;
      hrefWithHandle ='/pages/store-locator';
    }

    window.location.assign(hrefWithHandle);
  }

  let contactClickBound = false;

  function init() {
    updateContactButtons();

    window.addEventListener('preferred-store-updated', () => {
      updateContactButtons();
    });

    document.addEventListener('location:changed', () => {
      updateContactButtons();
    });

    if (!contactClickBound) {
      contactClickBound = true;
      document.addEventListener('click', handleCategoryFaqContactClick, true);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
